import { appRoot } from '@/router'

export default {
  render() {
    // 何もレンダリングしない
  },
  created: appRoot
}
